import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Select, Button } from "antd";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
const CommunicationMatrixVendor = ({
  VendorId,
  communicationMatrixId,
  setCommunicationMatrixId,
  gstVendorId,
  gstValue,
}) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;

  const initialState = {
    vendor_communication_matrix: [
      {
        company: CompanyId,
        name: null,
        email: null,
        vendor_matrix_steps: [],
        phone_number: null,
        designation: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);

  const [btnLoading, setBtnLoading] = useState(false);
  const [vendorMatrixSteps, setVendorMatrixSteps] = useState([]);
  const [apiLoading, setapiloading] = useState(false);

  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.vendor_communication_matrix;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, vendor_communication_matrix: newPersonArr });
  };
  const removePerson = async (lastIndex) => {
    let filterPersonArr = state.vendor_communication_matrix.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, vendor_communication_matrix: filterPersonArr });
    setWeightSizeFieldValue(filterPersonArr);
  };

  const handleCloneSelectChange = (field, value, index) => {
    setState((prevState) => {
      const newFeatureArr = [...prevState.vendor_communication_matrix];
      if (newFeatureArr[index]) {
        console.log("newFeatureArr", newFeatureArr);
        newFeatureArr[index] = {
          ...newFeatureArr[index],
          [field]: value,
        };
      }
      return { ...prevState, vendor_communication_matrix: newFeatureArr };
    });
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["name" + objectKey] = objectValue.name;
      fieldObject["designation" + objectKey] = objectValue.designation;
      fieldObject["email" + objectKey] = objectValue.email;

      fieldObject["vendor_matrix_steps" + objectKey] =
        objectValue?.vendor_matrix_steps || [];
      fieldObject["phone_number" + objectKey] = String(
        objectValue.phone_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const addPerson = () => {
    let newPersonArr = [
      ...state.vendor_communication_matrix,
      {
        company: CompanyId,
        name: null,
        designation: null,
        email: null,
        vendor_matrix_steps: [],
        phone_number: null,
      },
    ];
    setState({ ...state, vendor_communication_matrix: newPersonArr });
    setWeightSizeFieldValue(newPersonArr);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.vendor_communication_matrix;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, vendor_communication_matrix: newPersonArr });
  };

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const vendor = gstVendorId ? gstVendorId : VendorId;
        const apiResponse = await getRequest(
          `vendor-communication-matrix/?vendor_id=${vendor}&company_id=${CompanyId}`
        );

        if (apiResponse.data.success) {
          setState((prevState) => {
            const updatedVendorMatrix = apiResponse.data.data.map(
              (keyPerson) => {
                const {
                  id,
                  vendor,
                  vendor_name,
                  vendor_matrix_steps,
                  ...rest
                } = keyPerson;

                const updatedVendorMatrixSteps = vendor_matrix_steps.map(
                  (step) => step.id
                );
                return {
                  company: CompanyId,
                  vendor_matrix_steps: updatedVendorMatrixSteps,
                  ...rest,
                };
              }
            );

            console.log(
              "Updated vendor communication matrix:",
              updatedVendorMatrix
            );

            return {
              ...prevState,
              vendor_communication_matrix: updatedVendorMatrix,
            };
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { id, vendor, vendor_name, vendor_matrix_steps, ...rest } =
                keypersonDetail;
              const modifiedVendorMatrixSteps = vendor_matrix_steps.map(
                (step) => step.id
              );
              return {
                ...rest,
                vendor_matrix_steps: modifiedVendorMatrixSteps,
              };
            }
          );

          setWeightSizeFieldValue(modifiedKeypersons);
        } else {
          console.log("Error: API call failed");
        }
        setapiloading(false);
      } catch (error) {
        console.error("Error during API call:", error);
        setapiloading(false);
      }
    };

    if (VendorId !== null && gstVendorId === null) {
      getVendorOnboarding();
    }

    if (gstVendorId === null && VendorId === null) {
      setState(initialState);
      formRef.current.setFieldsValue({ initialState });
      const modifiedKeypersons = initialState.vendor_communication_matrix.map(
        (keypersonDetail) => {
          const { id, vendor, vendor_name, ...rest } = keypersonDetail;
          return rest;
        }
      );
      setWeightSizeFieldValue(modifiedKeypersons);
    }

    getMatrixSteps();
  }, [VendorId, gstVendorId, t, gstValue]);

  const getMatrixSteps = async (data) => {
    await getRequest(`vendor-matrix-steps/?no_pagination=True`, data).then(
      (response) => {
        setVendorMatrixSteps(response.data?.data);
      }
    );
  };

  const handleSubmit = async () => {
    console.log(
      "state.vendor_communication_matrix",
      state.vendor_communication_matrix
    );
    const isInvalidRow = state.vendor_communication_matrix.some(
      (person) =>
        !person.name ||
        !person.designation ||
        !person.email ||
        (Array.isArray(person.vendor_matrix_steps) &&
          person.vendor_matrix_steps.length === 0) ||
        !person.phone_number
    );

    if (isInvalidRow) {
      ErrorNotificationMsg(t("Please Fill All Fields"));
      return;
    }
    const payload = {
      vendor_communication_matrix:
        state.vendor_communication_matrix &&
        state.vendor_communication_matrix.every(
          (person) =>
            person.name === null &&
            person.designation === null &&
            person.email === null &&
            person.vendor_matrix_steps === null &&
            person.phone_number === null
        )
          ? []
          : state.vendor_communication_matrix.map((person) => ({
              ...person,
              company: CompanyId,
            })),
    };

    try {
      setBtnLoading(true);
      let response;

      if (
        communicationMatrixId === null ||
        communicationMatrixId === undefined
      ) {
        const url =
          VendorId !== null
            ? `vendor-communication-matrix/${VendorId}/add-communication-matrix/`
            : `vendor-communication-matrix/${gstVendorId}/add-communication-matrix/`;
        response = await patchRequest(url, payload);
      } else {
        const url =
          VendorId !== null
            ? `vendor-communication-matrix/${VendorId}/`
            : `vendor-communication-matrix/${gstVendorId}/`;

        response = await patchRequest(url, payload);
        response = await patchRequest(
          `vendor-communication-matrix/${VendorId}/`,
          payload
        );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          communicationMatrixId === null || communicationMatrixId === undefined
            ? t("vendor_communication_detail_added")
            : t("vendor_communication_detail_updated")
        );
        setCommunicationMatrixId(
          response.data.data.vendor_communication_matrix[0].id
        );
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  return (
    <>
      <Spin spinning={apiLoading}>
        <Form autoComplete="off" ref={formRef}>
          {state.vendor_communication_matrix &&
            state.vendor_communication_matrix.map((x, index) => {
              return (
                <>
                  <Row key={index} className="customcol" gutter={[15]}>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={3}
                      xl={3}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`name` + index}
                        label={t("pl_personName")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Enter Valid Name")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Please Enter Valid Name",
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_personName1")}
                          onChange={(value) =>
                            handleCloneInputChange("name", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={3}
                      xl={3}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`designation` + index}
                        label={t("lbb_designation")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Enter designation")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Please Enter Valid Designation",
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_designation")}
                          onChange={(value) =>
                            handleCloneInputChange("designation", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={5}
                      xl={5}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`email` + index}
                        label={t("lbb_email")}
                        rules={[
                          {
                            required: true,
                            type: "email",
                            message: <Trans>{t("val_email")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_email")}
                          onChange={(value) =>
                            handleCloneInputChange("email", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={5} xl={5}>
                      <div className="verifywrap">
                        <Form.Item
                          name={`phone_number` + index}
                          label={t("pl_ContactNo")}
                          pattern={"/^d{12}$/"}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("Enter Phone Number")}</Trans>,
                            },
                            {
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                            {
                              pattern: /^\d{12}$/,
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                          ]}
                        >
                          <PhoneInput
                            className="PhoneSection"
                            country={"in"}
                            onChange={(phone) =>
                              handleClonePhoneInputChange(
                                "phone_number",
                                phone,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                      <Form.Item
                        name={`vendor_matrix_steps` + index}
                        label={t("Communication Step")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Enter Step")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          mode="multiple"
                          allowClear
                          placeholder="Select vendor steps"
                          maxTagCount="responsive"
                          style={{ width: '100%' }}
                          onChange={(value) =>
                            handleCloneSelectChange(
                              "vendor_matrix_steps",
                              value,
                              index
                            )
                          }
                        >
                          {vendorMatrixSteps.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={2} xl={2}>
                      <div className="addwrp">
                        <Space>
                          {index !== 0 ? (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removePerson(index)}
                            />
                          ) : (
                            ""
                          )}
                          <PlusSquareFilled
                            className="add"
                            onClick={(e) => addPerson(e)}
                          />
                        </Space>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            })}
          {VendorId || gstVendorId ? (
            <div className="subbuttonsrow">
              <Button
                type="primary"
                className="primary"
                icon={<SaveOutlined />}
                onClick={handleSubmit}
                loading={btnLoading}
              >
                Save
              </Button>
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin>
    </>
  );
};
CommunicationMatrixVendor.propTypes = {
  VendorId: PropTypes.number,
  communicationMatrixId: PropTypes.number,
  setCommunicationMatrixId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
};
export default CommunicationMatrixVendor;
